export default __webpack_public_path__ + "static/logo-white-70025be3aa3bf8b74787c4462c90566a.png";